import { Inline, vars } from '@etg/wings';
import { Illustration } from '@eti/components';
import { useDirection, useSiteContext, useTranslation } from '@eti/providers';
import { css, cx } from '@eti/styles';
import { Link } from 'react-router-dom';
import { routes } from '../../../../constants/routesAndApisConstants';
import Banner from '../../../../common/components/Banner';
import { linkStyles } from '../../../../utils/styleUtils';

const cardStyles = css`
  overflow: hidden;
`;

const contentStyles = css`
  padding-inline-start: 16px;
`;

const illustrationWrapperStyles = css`
  align-self: stretch;
  background-color: ${vars.colors.promotional.light};
`;

const marginStyles = css`
  margin-top: auto;
`;

const SearchFlightsBanner = () => {
  const { t } = useTranslation();
  const { brand } = useSiteContext();
  const { isRTL } = useDirection();

  return (
    <Banner
      cardClassName={cardStyles}
      contentClassName={contentStyles}
      data-testid="my-bookings-search-flights"
      description={t('MyBookingsWelcomePage.Banner.SearchFlights.Description')}
      footer={
        <Link
          className={cx(linkStyles, marginStyles)}
          data-testid="my-bookings-contact-us-link"
          to={routes.START}
        >
          {t('MyBookingsWelcomePage.SearchFlights.Link.Text')}
        </Link>
      }
      icon={
        <Inline align="center" alignY="center" className={illustrationWrapperStyles}>
          <Illustration
            brand={brand.code}
            data-testid="my-bookings-search-flights-icon"
            height={112}
            id="search-flights-banner"
            mirrored={isRTL}
            width={116}
          />
        </Inline>
      }
      title={t('MyBookingsWelcomePage.Banner.SearchFlights.Title')}
    />
  );
};

export default SearchFlightsBanner;
